import component from "../../legacy/UnavailableMessage"

export default component
